import { post } from '../assets/js/kumaprotoutil'

const pb = require('@/assets/js/kumaproto').kuma.jp.protobuf.common

export default {
  methods: {
    isErrorPage() {
      return this.$route.path.startsWith('/error')
    },
    hasNetworkError(err) {
      if (err.message === undefined || err.message === null) {
        return false
      }
      if (err.message !== "Network Error") {
        return false
      }
      return true
    },
    hasInvalidToken(err) {
      if (err.response === undefined || err.response === null || err.response.status === undefined || err.response.status === null) {
        return false
      }
      if (err.response.status !== 403) {
        return false
      }
      return true
    },
    // Note: error は this.post() 呼び出し元でもキャッチされる
    post(cmdNo, encoded) {
      const seqNo = this.$store.getters.incrementedSequenceNumber
      const token = this.$store.getters.token
      this.$store.state.isConnecting = true
      this.$store.state.isMentenance = false
      return new Promise((resolve, reject) => {
        post(seqNo, token, cmdNo, encoded)
          .then(decoded => {
            this.$store.state.isConnecting = false
            resolve(decoded)
          })
          .catch(err => {
            this.$store.state.isConnecting = false
            if (this.isErrorPage()) {
              // eslint-disable-next-line no-console
              console.error(err)
            } else if (err instanceof pb.Maintenance) {
              this.$store.state.isMentenance = true
              this.$_error('Error', {title: err.message, statusCode: 300})
            } else if (err instanceof pb.KumaError) {
              this.$_error('Error', {title: err["class"], statusCode: err.code, data: err})
            } else if (this.hasNetworkError(err)) {
              this.$_error('Error', { title: '通信エラー', statusCode: 200 })
            } else if (this.hasInvalidToken(err)) {
              this.$store.dispatch('logout')
              this.$_error('Error', { title: '継続ログイン解除', statusCode: 412 })
            } else {
              // eslint-disable-next-line no-console
              console.error(err)
              reject(err)
            }
          })
      })
    }
  },
  
  mounted () {
    this.$store.state.isConnecting = false
  }
}
